import { render, staticRenderFns } from "./TableModal.vue?vue&type=template&id=0aa618b6&scoped=true&"
import script from "./TableModal.vue?vue&type=script&lang=js&"
export * from "./TableModal.vue?vue&type=script&lang=js&"
import style0 from "./TableModal.vue?vue&type=style&index=0&id=0aa618b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa618b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\07.00\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa618b6')) {
      api.createRecord('0aa618b6', component.options)
    } else {
      api.reload('0aa618b6', component.options)
    }
    module.hot.accept("./TableModal.vue?vue&type=template&id=0aa618b6&scoped=true&", function () {
      api.rerender('0aa618b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/ui/TableModal.vue"
export default component.exports